<template>
  <section id="intro" class="section-block section-block--soft">
    <div class="section-container">
      <span v-reveal class="section-label">About Us</span>
      <h2 v-reveal class="section-title">公司简介</h2>
      <p v-reveal class="section-subtitle reveal--delay-1">
        深耕跨境电商信息化，打造稳定高效的一体化管理系统
      </p>
      <div v-reveal class="reveal--delay-2 intro-body">
        <p v-for="(line, i) in paragraphs" :key="i">{{ line }}</p>
      </div>
    </div>
  </section>
</template>

<script>
import { companyIntroParagraphs } from "../defaultHomeContent";

export default {
  data() {
    return {
      paragraphs: companyIntroParagraphs
    };
  }
};
</script>

<style scoped>
.intro-body p {
  margin: 0 0 20px;
  font-size: 0.98rem;
  line-height: 1.9;
  color: var(--text-muted);
  text-align: justify;
}

.intro-body p:last-child {
  margin-bottom: 0;
}
</style>
